import { pick } from 'lodash';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

import { AppVersion } from 'click-types';
import { appInfoSelector } from '@common/redux/selectors/app';

const createStyles = (attributes: any) => {
  const appInfo = useSelector(appInfoSelector);
  const isV3 = appInfo?.version === AppVersion.V3;
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes?.style;

  return StyleSheet.create({
    container: {
      ...pick(attributes, [
        'marginTop',
        'marginLeft',
        'width',
        'opacity',
        // 'height', // FIXME: when fix position multiple form in pc
      ]),
      // For V4, override with style object properties if they exist
      ...(!isV3 &&
        attributes.style?.width && { width: attributes.style.width }),
      ...(!isV3 &&
        attributes.style?.height && { height: attributes.style.height }),
      ...(!isV3 &&
        attributes.style?.opacity !== undefined && {
          opacity: attributes.style.opacity,
        }),
      zIndex: attributes.zIndex,
      ...(isV4 &&
        pick(style, [
          'top',
          'left',
          'bottom',
          'right',
          'position',
          'margin',
          'marginTop',
          'marginLeft',
          'marginBottom',
          'marginRight',
        ])),
      // Handle transform separately to ensure it's an array
      ...(isV4 &&
        style?.transform &&
        Array.isArray(style.transform) && {
          transform: style.transform,
        }),
    },
    wrapper: {},
    img: {
      ...pick(attributes, ['width', 'height', 'borderRadius', 'opacity']),
      ...(attributes.borderStyle !== 'none'
        ? pick(attributes, ['borderWidth', 'borderColor'])
        : {}),
    },
  });
};

export default createStyles;
